import axios from "@/axios";

const api = {
  fetchRevettingTimeline: async ({ case_id, case_entity_id, tenant_check_id }) => {
    const response = await axios.get(`/case/${case_id}/entity/${case_entity_id}/revetting-timeline`, {
      params: {
        ...(tenant_check_id ? { tenant_check_id } : {}),
      },
    });

    return response.data;
  },

  fetchComparedForms: async ({ case_id, case_entity_id, version_a, version_b, tenant_check_id }) => {
    const response = await axios.post(`case/${case_id}/entity/${case_entity_id}/compare-forms`, {
      version_a,
      version_b,
      ...(tenant_check_id ? { tenant_check_id } : {}),
    });

    return response.data;
  },

  getRefreshConfiguration: async (case_id) => {
    const response = await axios.get(`case/refresh-configuration/${case_id}`);
    return response.data;
  },

  postRefreshConfiguration: async (payload) => {
    const response = await axios.post(`case/refresh-configuration`, payload);
    return response.data;
  },

  putRefreshConfiguration: async (config_id, payload) => {
    const response = await axios.put(`case/refresh-configuration/${config_id}`, payload);
    return response.data;
  },

  getNextRefreshDate: async (config_id) => {
    const response = await axios.get(`case/refresh-configuration/${config_id}/next-refresh-date`);
    return response.data;
  },

  startCaseRevetting: async (case_id) => {
    const url = `case/${case_id}/revetting-start`;
    const response = await axios.post(url);
    return response.data;
  },

  stopCaseRevetting: async (case_id) => {
    const url = `case/${case_id}/revetting-end`;
    const response = await axios.post(url);
    return response.data;
  },
}

export default api;
